/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.ServicesWizard {
    'use strict';


    interface IMainServicesWizardTabsController {
        currentStep: number;
        lastTab: number;
        isEditMode: boolean;
        initializeEditMode: () => void;
        save: (form: any) => void;
        cancelWizard: () => void;
    }

    class MainServicesWizardTabsController implements IMainServicesWizardTabsController {
       
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.plugins.servicesWizard.ServicesWizardService',
            'meevo.components.busy.BusyService',
            '$q',
            "meevo.components.modal.ModalService",
            '$mdDialog'
        ];
        public tabToggle: boolean;
        public currentStep: number = 0;
        public lastTab = 5;
      
        public isEditMode: boolean = false;

        public params = {
          
            triggeredByList: [],
            receivedByList: [],
          
            dataForReview: []
           
        };

        get editMode(): boolean {
            return true;
        }

        constructor(protected $scope: angular.IScope,
                    protected $rootScope: ng.IRootScopeService,
                    protected $state: angular.ui.IState,
                    protected servicesWizardService: IServicesWizardService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $q: angular.IQService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    private $mdDialog: angular.material.IDialogService
               ) {


            if (this.editMode) {
                this.currentStep = 0;
            }
        }

        private servicesWizardModal: Meevo.Components.Modal.IModalOptions = {
            clickOutsideToClose: false,
            templateUrl: "app/plugins/servicesWizard/modals/launch.services.html",
            controller: "meevo.plugins.servicesWizard.mainServicesWizardTabsController",
            controllerAs: "wizard",
            bindToController: true,
            locals: { showInfo: true, isImported: true }
        }

        /**
         * Initialize Edit Mode
         */
        initializeEditMode(): void {
      
        }

        onTabSelected(tabNumber: number): void {
            if (tabNumber == 1) {
                this.tabToggle = true;
            } else {
                    this.loadServiceSList();
                    this.tabToggle = false;
               
            }
        }



        unSelectOptions(): void {
            this.servicesWizardService.getServiceCategoryList().then((data) => data);
            if (Model.Guard.isSomething(this.servicesWizardService.selectedServiceList) && this.servicesWizardService.selectedServiceList.length > 0)
                this.servicesWizardService.selectedServiceList = null;
            if (Model.Guard.isSomething(this.servicesWizardService.selectedServiceCatList) && this.servicesWizardService.selectedServiceCatList.length > 0) {
                for (var i = 0; i <= this.servicesWizardService.serviceCatList["serviceCategoryPage"].length; i++) {
                    for (var x = 0; x <= this.servicesWizardService.serviceCatList["serviceCategoryPage"][i].serviceCategoryWizardList.length;x++)
                        this.servicesWizardService.serviceCatList["serviceCategoryPage"][i].serviceCategoryWizardList[x].isChecked = false;
                }
            }
          this.servicesWizardService.selectedServiceCatList = null;
        }

        /**
         * Create New Alert
         */
        save(form:any): void {
            if (!this.servicesWizardService.selectedServiceList || (this.servicesWizardService.selectedServiceList.length <= 0)) {
                this.modalService.alert("MESSAGE_INVALID_SERVICEWIZARD_NO_IMPORT");
                return;
            }
            
            if (!form.$valid) {
                this.modalService.alert("MESSAGE_INVALID_SAVE");
                return;
            }
            this.modalService
                .confirm('LABEL_SERVICES_WIZARD_SAVE_CONFIRM')
                .then((answer: boolean) => {
                    if (answer) {
                        this.busyService.start();
                        //   this.servicesWizardService.usageTrackingLog(Model.NounEnum.AlertManager, Model.VerbEnum.SaveButtonClicked);
                        this.servicesWizardService.importServicesData()
                            .then(() => {
                                this.servicesWizardModal.locals['showInfo'] = true;
                                this.servicesWizardModal.locals['isImported'] = true;
                                this.modalService.showCustom(this.servicesWizardModal);
                                this.goToBackStep();
                                this.servicesWizardService.selectedServiceList = null;
                                this.unSelectOptions();
                                
                            })
                            .finally(() => {
                                
                                this.busyService.stop();
                            });
                    }

                });
         
        }



       /* Go to the next step
        */
        goToNextStep(): void {
            this.currentStep = 1;
        }


        /**
      * Go to the next step
      */
        goToBackStep(): void {
            this.currentStep = 0;
        }



        loadServiceSList(): ng.IPromise<void> {
            if (Model.Guard.isNothing(this.servicesWizardService.selectedServiceCatList) || this.servicesWizardService.selectedServiceCatList.length == 0 )
                return;
            if (Model.Guard.isSomething(this.servicesWizardService.selectedServiceList) && this.servicesWizardService.selectedServiceList.length > 0) {
                this.servicesWizardService.selectedServiceList.splice(0, this.servicesWizardService.selectedServiceList.length);
              }
            this.busyService.start();

            return new this.$q(resolve => {

                this.servicesWizardService.getServicesList().then((data) => resolve(data));

            }).then((data: any) => {
                this.servicesWizardService.serviceList = data;
                for (var i = 0; i < this.servicesWizardService.serviceList['serviceWizardListItems'].length; i++) {

                    for (var j = 0; j < this.servicesWizardService.selectedServiceCatList.length; j++) {

                        if (this.servicesWizardService.serviceList['serviceWizardListItems'][i].serviceCatInfo.id ==
                            this.servicesWizardService.selectedServiceCatList[j].id) {
                            this.servicesWizardService.serviceList['serviceWizardListItems'][i].serviceCatInfo =
                                this.servicesWizardService.selectedServiceCatList[j];
                            break;
                        }
                    }
                }

            }).finally(() => {
                this.busyService.stop();
            });
        }


        /**
         * Display list of created Alerts
         */
        cancelWizard(): void {

            this.modalService
                .warning('LABEL_SERVICES_WIZARD_CANCEL', 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then((answer: boolean) => {
                    if (answer) {
                       
                        this.servicesWizardService.selectedServiceList = null;
                        this.servicesWizardService.selectedServiceCatList = null;

                        this.servicesWizardService.getServiceCategoryList().then((data) =>
                            this.servicesWizardService.serviceCatList = data);
                        this.currentStep = 0; 
                        this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
                    }

                });
        }

        /* close modal */
        close() {
            return this.$mdDialog.hide();
        }

      
    }

    angular.module('meevo.plugins.servicesWizard')
        .controller('meevo.plugins.servicesWizard.mainServicesWizardTabsController', MainServicesWizardTabsController);
}
